import { getRegionId } from "features/page-model/ducks/get-model";
import { useSelector } from "react-redux";
import { SpbKredit } from "./spb-kredit";
import { MasterKredit } from "./master-kredit";
import { REGION_ID } from "common/constants";

export const KreditPage: React.FC = () => {
  const regionId = useSelector(getRegionId);

  if(regionId === REGION_ID.SPB) {
    return <SpbKredit />
  }

  return <MasterKredit />
};
